import metaService from "@/services/metaService"

import { CITIES_SEARCH } from "./actionTypes"
import {
  CITIES_RESET_SEARCH,
  CITIES_SEARCH_ABORT,
  CITIES_SEARCH_FAILURE,
  CITIES_SEARCH_REQUEST,
  CITIES_SEARCH_SAVE_CANCEL_TOKEN,
  CITIES_SEARCH_SUCCESS
} from "./mutationTypes"

const state = () => ({
  loading: false,
  /**
   * {
   *   name: String,
   *   uuid: String
   * }
   */
  cities: [],
  lastSearchValue: null,
  cancelToken: null
})

const mutations = {
  [CITIES_SEARCH_REQUEST]: (state) => {
    state.loading = true
  },

  [CITIES_SEARCH_SUCCESS](state, { data = {}, value = "" } = {}) {
    const { results: cities = [] } = data

    state.lastSearchValue = value
    state.cities = cities
    state.loading = false
  },

  [CITIES_SEARCH_FAILURE]: (state) => {
    state.loading = false
  },

  [CITIES_SEARCH_SAVE_CANCEL_TOKEN]: (state, cancel) => {
    state.cancelToken = cancel
  },

  [CITIES_SEARCH_ABORT]: (state) => {
    if (state.cancelToken) {
      state.cancelToken()
      state.cancelToken = null
      state.loading = false
    }
  },

  [CITIES_RESET_SEARCH](state) {
    if (state.cancelToken) {
      state.cancelToken()
    }

    state.loading = false
    state.cities = []
    state.lastSearchValue = null
    state.cancelToken = null
  }
}

const actions = {
  async [CITIES_SEARCH]({ state, commit }, city = "") {
    const executor = (c) => commit(CITIES_SEARCH_SAVE_CANCEL_TOKEN, c)

    if (state.loading && state.cancelToken) {
      commit(CITIES_SEARCH_ABORT)
    }

    commit(CITIES_SEARCH_REQUEST)

    try {
      const response = await metaService.citySearch({ city, executor })

      commit(CITIES_SEARCH_SUCCESS, { data: response.data, value: city })
    } catch (e) {
      commit(CITIES_SEARCH_FAILURE)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
